<template>
    <div v-wechat-title="title" style="height: 100%">
        <crud-facecade
            ref="events-list"
            :url="url"
            :columns="columnList"
            :buttons="[]"
            dialogWidth="80%"
            :tableHeight="tableHeight"
            :addButton="{ enabled: false }"
            :updateButton="{ enabled: false }"
            @loadDetailEventView="loadDetailEventView"
            @printOne="printOne"
            @reportEvent="reportEvent"
            @reviewEvent="reviewEvent"
            :isDisplayCount="true"
        >
            <slot slot="filter">
                <el-col :md="8" :lg="6" :xl="5">
                    <item-input type="daterange" v-model="rdate" :noPadding="true"></item-input>
                </el-col>
                <el-col :md="5" :lg="4" :xl="3">
                    <item-input type="groupselect" v-model="dic_ward_id" :options="ward_auth" :clearable="true" placeholder="请选择区域"></item-input>
                </el-col>
            </slot>
        </crud-facecade>
        <!--创建不良事件-->
        <el-dialog class="form-table-h380" title="查看" :visible.sync="loadEventView.dialogFormVisible" :close-on-click-modal="false" width="50%">
            <cus-form ref="form-voice" :data="loadEventView.data" :columns="loadEventViewColumns"></cus-form>
            <div class="dialog-footer">
                <el-button type="primary" v-show="!showAdverseEventStatus || loadEventView.data.event_status == 2" v-has-permission="printPermission" style="float: right; margin: 10px" @click="loadDoc(loadEventView.data)">打印</el-button>
                <el-button type="danger" v-show="showAdverseEventStatus && (loadEventView.data.event_status == 0 || loadEventView.data.event_status == 1)" style="float: right; margin: 10px" @click="rejectEvent(loadEventView.data)">驳回</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name: `EventStatistic`,
    data() {
        return {
            title: `不良事件统计`,
            loadEventView: {
                dialogFormVisible: false,
                data: {}
            },
            event_group: [],
            o_dic_ward_id: undefined,
            issetoperatingward: false,
            adverse_count: 0,
            rdate: [
                this.$moment()
                    .add(-1, `Month`)
                    .format(`YYYY/MM/DD`),
                this.$moment().format(`YYYY/MM/DD`)
            ],
            url: {
                area: `EventStatistic`,
                baseUrl: ``,
                get: () => {
                    return new Promise((resolve, reject) => {
                        this.loadEvents()
                            .then(data => {
                                this.adverse_count = data.length
                                resolve(data)
                            })
                            .catch(e => {
                                console.log(e)
                            })
                    })
                }
            },
            showAdverseEventStatus: this.$root.ShowAdverseEventStatus && this.$root.ShowAdverseEventStatus == `1`,
            printPermission: `adverse_event:print`,
            eventStatus: [
                { label: `已驳回`, value: -1 },
                { label: `未处理`, value: 0 },
                { label: `已上报`, value: 1 },
                { label: `已审核`, value: 2 }]
        }
    },
    computed: {
        ...mapGetters([`sys_enums`, `currentUser`, `ward_auth`, `active_ward`, `screenHeight`]),
        tableHeight() {
            return (this.screenHeight && this.screenHeight - 190) || 0
        },
        dic_ward_id: {
            get: function() {
                if (!this.issetoperatingward && this.active_ward) {
                    this.o_dic_ward_id = this.active_ward.value
                }
                return this.o_dic_ward_id
            },
            set: function(v) {
                this.o_dic_ward_id = v
                this.issetoperatingward = true
            }
        },
        columnList() {
            let me = this
            return [
                {
                    type: `string`,
                    prop: `id`,
                    label: `编号`,
                    isKey: true
                },
                {
                    type: `string`,
                    prop: `patient_name`,
                    label: `姓名`,
                    isListable: true,
                    searchable: true
                },
                {
                    type: `string`,
                    prop: `dic_section`,
                    label: `科室`,
                    isListable: true,
                    searchable: true
                },
                {
                    type: `string`,
                    prop: `visit_no`,
                    label: this.T(`adverse_event_statistic.visit_no`),
                    isListable: true,
                    queryable: true,
                    searchable: true
                },
                {
                    type: `select`,
                    prop: `enum_event_type`,
                    label: `属性`,
                    isListable: true,
                    searchable: true,
                    options: this.sys_enums.AdverseEventType || []
                },
                {
                    type: `string`,
                    prop: `group_name`,
                    label: `事件类型`,
                    isListable: true,
                    searchable: true
                },
                {
                    type: `string`,
                    prop: `name`,
                    label: `事件名称`,
                    isListable: true,
                    searchable: true
                },
                {
                    type: `select`,
                    prop: `event_status`,
                    label: `状态`,
                    width: `80`,
                    options: this.eventStatus,
                    isListable: this.showAdverseEventStatus
                },
                {
                    type: `string`,
                    prop: `case_type`,
                    label: `病例类型`,
                    isListable: true,
                    searchable: true
                },
                {
                    type: `string`,
                    prop: `occur_time`,
                    label: `发生时间`,
                    width: `120`,
                    isListable: true,
                    sortable: true
                },
                {
                    type: `string`,
                    prop: `modify_date`,
                    label: `报告时间`,
                    width: `120`,
                    isListable: true,
                    sortable: true
                },
                {
                    type: `string`,
                    prop: `anes_doctor`,
                    label: `麻醉医生`,
                    width: `120`,
                    isListable: true,
                    sortable: true
                },
                {
                    type: `string`,
                    prop: `modifier`,
                    label: `报告人`,
                    isListable: true
                },
                {
                    type: `buttongroup`,
                    prop: `oper`,
                    label: `操作`,
                    width: `150`,
                    fixed: `right`,
                    isListable: true,
                    readonly: false,
                    options: (that, { row }) => {
                        let r = []
                        if (me.showAdverseEventStatus && row.event_status == 0) {
                            r.push({
                                class: `is-plain`,
                                label: `上报`,
                                icon: ``,
                                type: `primary`,
                                emit: `reportEvent`,
                                permission: `default`
                            })
                        } else if (me.showAdverseEventStatus && row.event_status == 1) {
                            r.push({
                                class: `is-plain`,
                                label: `审核`,
                                icon: ``,
                                type: `primary`,
                                emit: `reviewEvent`,
                                permission: `default`
                            })
                        }
                        r.push({
                            class: `is-plain`,
                            label: `查看`,
                            icon: ``,
                            type: `primary`,
                            emit: `loadDetailEventView`,
                            permission: `default`
                        })
                        if ((me.showAdverseEventStatus && row.event_status == 2) || !me.showAdverseEventStatus) {
                            r.push({
                                class: `is-plain`,
                                label: `打印`,
                                icon: `el-icon-printer`,
                                type: `primary`,
                                emit: `printOne`,
                                permission: `adverse_event:print`,
                                tooltip: `打印`
                            })
                        }
                        return r
                    }
                }
            ]
        },
        loadEventViewColumns() {
            return [
                {
                    type: `string`,
                    prop: `group_name`,
                    label: `事件类型`,
                    colspan: 12,
                    readonly: true
                },
                {
                    type: `string`,
                    prop: `name`,
                    label: `事件名称`,
                    colspan: 12,
                    readonly: true
                },
                {
                    type: `string`,
                    prop: `event_grade`,
                    label: `不良反应等级`,
                    colspan: 12,
                    readonly: true
                },
                {
                    type: `string`,
                    prop: `occur_time`,
                    label: `发生时间`,
                    colspan: 12,
                    readonly: true
                },
                {
                    type: `string`,
                    prop: `place`,
                    label: `发生场所`,
                    colspan: 12,
                    readonly: true
                },
                {
                    type: `string`,
                    prop: `case_type`,
                    label: `病例类型`,
                    colspan: 12,
                    readonly: true
                },
                {
                    type: `string`,
                    prop: `present`,
                    label: this.T(`adverseEvent.present`),
                    colspan: 12,
                    readonly: true
                },
                {
                    type: `string`,
                    prop: `adverse_consequence`,
                    label: `不良后果`,
                    colspan: 12,
                    readonly: true
                },
                {
                    type: `textarea`,
                    prop: `event_declaration`,
                    label: `事件经过`,
                    colspan: 24,
                    readonly: true
                },
                {
                    type: `textarea`,
                    prop: `cause`,
                    label: `原因分析`,
                    colspan: 24,
                    readonly: true
                },
                {
                    type: `textarea`,
                    prop: `measure`,
                    label: `处置措施`,
                    colspan: 24,
                    readonly: true
                },
                {
                    type: `textarea`,
                    prop: `consequence`,
                    label: `结果`,
                    colspan: 24,
                    readonly: true
                },
                {
                    type: `p`,
                    prop: `modifier`,
                    label: `报告人`,
                    colspan: 24
                }
            ]
        }
    },
    created() {
        this.init()
    },
    mounted() {},
    methods: {
        init() {
            return new Promise(resolve => {
                let req = this.myaxios.get(`/api/AcisSystem/AdverseCategory/Get`)
                req.then(data => {
                    this.event_group = _.map(data, d => {
                        return {
                            value: d.id,
                            label: d.name,
                            jianpin: d.abbr,
                            disabled: d.is_deleted
                        }
                    })
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        loadEvents() {
            return new Promise((resolve, reject) => {
                let that = this
                let req = that.myaxios.get(`/api/Nursing/AdverseEventHappen/Get?from=${that.rdate[0]}&to=${that.rdate[1]}`)
                req.then(data => {
                    let r = _.filter(data, d => {
                        return (that.dic_ward_id && that.dic_ward_id == `ow_${d.surgery_info && d.surgery_info.dic_operating_ward_id}`) || !this.dic_ward_id
                    })
                    if (r.length === 0) {
                        resolve(r)
                    } else {
                        data = _.map(r, d => {
                            return {
                                id: d.id,
                                patient_name: d.surgery_info && d.surgery_info.visit_info && d.surgery_info.visit_info.name,
                                visit_no: d.surgery_info && d.surgery_info.visit_info && d.surgery_info.visit_info.visit_no,
                                event_type: d.event_type,
                                group_name: d.dic_adverse_event && d.dic_adverse_event.group_name,
                                name: d.dic_adverse_event && d.dic_adverse_event.name,
                                occur_time: this.$moment(d.occur_time).format(`YYYY/MM/DD HH:mm`),
                                modify_date: this.$moment(d.modify_date).format(`YYYY/MM/DD HH:mm`),
                                modifier: d.modifier,
                                event_grade: d.event_grade,
                                consequence: d.consequence,
                                adverse_consequence: d.adverse_consequence,
                                present: d.present,
                                cause: d.cause,
                                measure: d.measure,
                                event_declaration: d.event_declaration,
                                place: d.place,
                                enum_event_type: d.enum_event_type,
                                dic_adverse_event_id: d.dic_adverse_event_id,
                                anes_doctor: d.anes_doctor,
                                enum_case_type: d.enum_case_type,
                                case_type: d.case_type,
                                anesthesia_time_stage: d.anesthesia_time_stage,
                                remark: d.remark,
                                event_status: d.event_status,
                                dic_section: d.surgery_info && d.surgery_info.dic_section
                                // adverse_type:d.dic_adverse_event&&d.dic_adverse_event.adverse_type
                            }
                        })
                        // this.adverse_count = data.length
                        resolve(data)
                    }
                })
            })
        },
        loadDetailEventView({ row }) {
            this.loadEventView.data = row
            this.loadEventView.dialogFormVisible = true
        },
        reportEvent({ row }) {
            let data = {
                id: row.id,
                event_status: 1
            }
            let req = this.myaxios.put(`/api/Nursing/AdverseEventHappen/Put`, data)
            req.then(data => {
                this.$message.success(`上报成功`)
                this.$refs[`events-list`].ReloadListData()
            }).catch(e => {
                console.log(e)
            })
        },
        reviewEvent({ row }) {
            let data = {
                id: row.id,
                event_status: 2
            }
            let req = this.myaxios.put(`/api/Nursing/AdverseEventHappen/Put`, data)
            req.then(data => {
                this.$message.success(`审核成功`)
                this.$refs[`events-list`].ReloadListData()
            }).catch(e => {
                console.log(e)
            })
        },
        rejectEvent(row) {
            let data = {
                id: row.id,
                event_status: -1
            }
            let req = this.myaxios.put(`/api/Nursing/AdverseEventHappen/Put`, data)
            req.then(data => {
                this.loadEventView.dialogFormVisible = false
                this.$message.success(`驳回成功`)
                this.$refs[`events-list`].ReloadListData()
            }).catch(e => {
                console.log(e)
            })
        },
        printOne({ row }) {
            this.loadDoc(row)
        },
        loadDoc(row) {
            this.$store.dispatch(`PRINT_PDF`, {
                host: this.$root.DOCSERVICE_BASE,
                params: {
                    docid: this.$root.DOCUMENT.BLSJ001,
                    id1: row.id,
                    objId: row.id
                }
            })
        }
    },
    watch: {
        dic_ward_id: function() {
            this.$refs[`events-list`].ReloadListData()
        },
        rdate: function() {
            this.$refs[`events-list`].ReloadListData()
        }
    }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/AdverseEvent/EventStatistic.vue